module.exports = __webpack_public_path__ + "img/pipe_hvac.530e0217.svg";